/* import __COLOCATED_TEMPLATE__ from './login-form.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask, task } from 'ember-concurrency';
import { object, string } from 'yup';
import { isServiceUnavailableError } from 'sh-www/utils/adapter-errors';
import { validateSchema } from 'sh-www/utils/validators';
import { inject as service } from '@ember/service';

class LoginFormComponent extends Component {
  @service session;

  @tracked username = '';
  @tracked password = '';
  @tracked errorMessage = null;
  @tracked errors = { };

  get disabled() {
    return this.authenticate.isRunning || this.googleSSOCallback.isRunning;
  }

  @action
  handleInput(field, value) {
    this[field] = value;
    this.errorMessage = null;

    if (this.errors[field]) {
      const { [field]: _, ...rest} = this.errors;
      this.errors = rest;
    }
  }

  @task
  *authenticate(e) {
    e.preventDefault();

    this.errorMessage = null;
    this.errors = { };

    const schema = object({
      username: string()
        .required('Please enter a valid email')
        .email('Please enter a valid email'),

      password: string()
        .required('Please enter a password'),
    });

    const [values, errors] = validateSchema(this, schema);

    if (errors) {
      this.errors = errors;
      return;
    }

    try {
      yield this.args.onSubmit(values.username, values.password);
    } catch (e) {
      if (isServiceUnavailableError(e)) {
        this.errorMessage = 'Page currently under maintenance, please try again in a few minutes.';
      } else {
        this.errorMessage = 'Could not log in. Please check your email and password, and try again.';
      }
    }
  }

  @dropTask
  *googleSSOCallback({ credential }) {
    try {
      yield this.args.onGoogleSSO(credential);
    } catch (e) {
      if (isServiceUnavailableError(e)) {
        this.errorMessage = 'Page currently under maintenance, please try again in a few minutes.';
      } else {
        this.errorMessage = 'Could not log in. If you have not logged in with Google before, please use your email and password, or create an account.';
      }
    }
  }
}

export default LoginFormComponent;
